var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"compliance-placeholder"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.title))]),_c('img',{attrs:{"src":_vm.images[_vm.image]}}),_c('p',[_vm._v(_vm._s(_vm.description))])])
}
var staticRenderFns = []

export { render, staticRenderFns }